(function(){
  "use strict";
  var $ = function(s,r){ return (r||document).querySelector(s); };
  var $$ = function(s,r){ return Array.prototype.slice.call((r||document).querySelectorAll(s)); };

  /* ---------------- entry gate (homepage only) ---------------- */
  var gate = $("#gate");
  if(gate){
    document.body.classList.add("locked");
    var enter = function(){
      if(gate.classList.contains("gate--exit")) return;
      gate.classList.add("gate--exit");
      document.body.classList.remove("locked");
      window.scrollTo(0,0);
      setTimeout(function(){ gate.style.display="none"; }, 800);
    };
    var eb = $("#gateEnter");
    if(eb) eb.addEventListener("click", enter);
    document.addEventListener("keydown", function(e){
      if((e.key==="Enter"||e.key===" ") && document.body.classList.contains("locked") && !gate.classList.contains("gate--exit")){
        e.preventDefault(); enter();
      }
    });
  }

  /* ---------------- product carousel ---------------- */
  var track = $("#pdpTrack");
  if(track){
    var slides = $$(".pdp__slide", track);
    var dots = $$("#pdpDots button");
    var idx = 0, count = slides.length;
    function go(n){
      idx = (n+count)%count;
      slides.forEach(function(s,i){ s.classList.toggle("active", i===idx); });
      dots.forEach(function(d,i){ d.classList.toggle("active", i===idx); });
    }
    dots.forEach(function(d,i){ d.addEventListener("click", function(){ go(i); }); });
    var prev=$("#pdpPrev"), next=$("#pdpNext");
    if(prev) prev.addEventListener("click", function(){ go(idx-1); });
    if(next) next.addEventListener("click", function(){ go(idx+1); });
    document.addEventListener("keydown", function(e){
      if(count<2) return;
      if(e.key==="ArrowLeft") go(idx-1);
      if(e.key==="ArrowRight") go(idx+1);
    });
  }

  /* ---------------- size -> variant selection ---------------- */
  var sizeWrap = $("#pdpSizes");
  if(sizeWrap){
    var addBtn = $("#addBtn");
    var variantInput = $("#variantId");
    $$("button", sizeWrap).forEach(function(b){
      b.addEventListener("click", function(){
        if(b.hasAttribute("disabled")) return;
        $$("button", sizeWrap).forEach(function(x){ x.classList.remove("active"); });
        b.classList.add("active");
        if(variantInput) variantInput.value = b.getAttribute("data-variant");
        if(addBtn){ addBtn.disabled = false; addBtn.textContent = "ADD"; }
      });
    });
  }

  /* ---------------- details panel ---------------- */
  var det = $("#det");
  var detOpen = $("#pdpDetailsOpen");
  var detClose = $("#detClose");
  if(det && detOpen){
    detOpen.addEventListener("click", function(){ det.classList.add("open"); });
    if(detClose) detClose.addEventListener("click", function(){ det.classList.remove("open"); });
    document.addEventListener("keydown", function(e){
      if(e.key==="Escape") det.classList.remove("open");
    });
  }

  /* ---------------- email signup (Klaviyo) ---------------- */
  var emailBtn = $("#emailBtn");
  if(emailBtn){
    var KLAVIYO_PUBLIC_KEY = emailBtn.getAttribute("data-klaviyo-key") || "WuniT2";
    var KLAVIYO_LIST_ID    = emailBtn.getAttribute("data-klaviyo-list") || "TW3Sey";
    var emailInput = $("#emailInput"), emailMsg = $("#emailMsg");
    function setMsg(t,cls){ emailMsg.textContent=t; emailMsg.className="signup__msg"+(cls?" "+cls:""); }
    function subscribe(){
      var email = (emailInput.value||"").trim();
      if(!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)){ setMsg("ENTER A VALID EMAIL","err"); return; }
      emailBtn.disabled = true; setMsg("SUBSCRIBING...");
      fetch("https://a.klaviyo.com/client/subscriptions/?company_id="+KLAVIYO_PUBLIC_KEY, {
        method:"POST",
        headers:{ "content-type":"application/json", "revision":"2024-10-15" },
        body: JSON.stringify({
          data:{ type:"subscription",
            attributes:{ custom_source:"PLAYGROUND storefront footer",
              profile:{ data:{ type:"profile", attributes:{ email: email } } } },
            relationships:{ list:{ data:{ type:"list", id: KLAVIYO_LIST_ID } } } }
        })
      }).then(function(res){
        if(res.ok || res.status===202){ setMsg("YOU'RE ON THE LIST","ok"); emailInput.value=""; }
        else { setMsg("SOMETHING WENT WRONG — TRY AGAIN","err"); emailBtn.disabled=false; }
      }).catch(function(){ setMsg("SOMETHING WENT WRONG — TRY AGAIN","err"); emailBtn.disabled=false; });
    }
    emailBtn.addEventListener("click", subscribe);
    emailInput.addEventListener("keydown", function(e){ if(e.key==="Enter"){ e.preventDefault(); subscribe(); } });
  }

  /* ---------------- logo fallback ---------------- */
  $$(".logo-slot").forEach(function(slot){
    var img = slot.querySelector("img"), txt = slot.querySelector(".logo-text");
    if(!img || !txt) return;
    if(img.complete && img.naturalWidth===0){ img.style.display="none"; txt.style.display="inline-block"; }
    img.addEventListener("error", function(){ img.style.display="none"; txt.style.display="inline-block"; });
  });
})();
